<template>
    <v-btn depressed small :color="getColorEstado(state)">
        {{ state }}
    </v-btn>
</template>

<script>
export default {
    data() {
            return {
                
            }
        },
    props:{
            state: String
        },
    methods: {
        getColorEstado(){
            const stateColorMap = {
                'pago_pendiente': 'yellow lighten-1',
                'pago_en_revision': 'blue lighten-3',
                'pago_rechazado': 'orange lighten-3',
                'pago_expirado': 'red lighten-3',
                'pago_realizado': 'green lighten-3',
                'pago_bonificado': 'green lighten-3',
                'pago_no_paga': 'grey lighten-2'
            };
            return stateColorMap[this.state] || 'grey lighten-4';
        },
    }
}
</script>